import { Component, OnInit } from '@angular/core';
 
import { Router } from '@angular/router';

@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.scss']
})
export class MyAccountComponent implements OnInit {
  user:any;
  public userName: string;
  roleName:any;
  branchOrRegionName:any;
  public profileImg: 'assets/images/dashboard/profile.jpg';
  jobTitle: any;

  constructor( public router : Router) {
    this.user=JSON.parse(localStorage.getItem('user'));
    if (this.user) {

      if(this.user.roleId==2 || this.user.roleId==3 || this.user.roleId==4){
        this.branchOrRegionName = this.user.branchName;
      }else if(this.user.roleId==5){
        this.branchOrRegionName = this.user.regionName;
      }
    } else {
    }

  }


  logoutFunc() {
    // this.authService.SignOut();
    localStorage.clear();
    this.router.navigate(['/login']).then(() => { window.location.reload();});
  }

  ngOnInit() {
    let user = JSON.parse(localStorage.getItem('user'));
    this.roleName = user.roleName;
    this.jobTitle = user.jobTitle;
    this.userName = user.fullName;
  }
  profile(){
    let user = JSON.parse(localStorage.getItem('user'));
    this.router.navigate([`violation/profile/${user['userIdEncrypt']}`])
  }

}
